import { ProgramType } from './programs';
import {
	FLUSH_PROGRAM,
	REQUEST_ACTIVE,
	REQUEST_ACTIVE_FAILURE,
	REQUEST_ACTIVE_LOADING,
	REQUEST_ACTIVE_SUCCESS,
	REQUEST_FINISH_BUTTON,
	REQUEST_FINISH_BUTTON_FAILURE,
	REQUEST_FINISH_BUTTON_SUCCESS,
	REQUEST_FINISH_MANUALLY,
	REQUEST_FINISH_MANUALLY_FAILURE,
	REQUEST_FINISH_MANUALLY_LOADING,
	REQUEST_FINISH_MANUALLY_SUCCESS,
} from './programs.actionTypes';

export const actionCreators = {
	doFlushPrograms: () => ({
		type: FLUSH_PROGRAM,
	}),
	doRequestActivePrograms: () => ({
		type: REQUEST_ACTIVE,
	}),
	doRequestActiveProgramsLoading: (status: any) => ({
		type: REQUEST_ACTIVE_LOADING,
		status,
	}),
	doRequestActiveProgramsSuccess: (activePrograms: any[]) => {
		return {
			type: REQUEST_ACTIVE_SUCCESS,
			activePrograms,
		};
	},
	doRequestActiveProgramsFailure: () => ({
		type: REQUEST_ACTIVE_FAILURE,
	}),
	doRequestFinishManually: (programId: string) => ({
		type: REQUEST_FINISH_MANUALLY,
		programId,
	}),
	doRequestFinishManuallyLoading: (status: boolean) => ({
		type: REQUEST_FINISH_MANUALLY_LOADING,
		status,
	}),
	doRequestFinishManuallySuccess: () => ({
		type: REQUEST_FINISH_MANUALLY_SUCCESS,
	}),
	doRequestFinishManuallyFailure: () => ({
		type: REQUEST_FINISH_MANUALLY_FAILURE,
	}),

	doRequestFinishProgramButton: () => ({
		type: REQUEST_FINISH_BUTTON,
	}),
	doRequestFinishProgramButtonSuccess: (activeProgram: ProgramType) => ({
		type: REQUEST_FINISH_BUTTON_SUCCESS,
		activeProgram,
	}),
	doRequestFinishProgramButtonFailure: () => ({
		type: REQUEST_FINISH_BUTTON_FAILURE,
	}),
};

export type ProgramsActionType =
	| ReturnType<typeof actionCreators.doFlushPrograms>
	| ReturnType<typeof actionCreators.doRequestActivePrograms>
	| ReturnType<typeof actionCreators.doRequestActiveProgramsLoading>
	| ReturnType<typeof actionCreators.doRequestActiveProgramsSuccess>
	| ReturnType<typeof actionCreators.doRequestActiveProgramsFailure>
	| ReturnType<typeof actionCreators.doRequestFinishManually>
	| ReturnType<typeof actionCreators.doRequestFinishManuallyLoading>
	| ReturnType<typeof actionCreators.doRequestFinishManuallySuccess>
	| ReturnType<typeof actionCreators.doRequestFinishManuallyFailure>
	| ReturnType<typeof actionCreators.doRequestFinishProgramButton>
	| ReturnType<typeof actionCreators.doRequestFinishProgramButtonSuccess>
	| ReturnType<typeof actionCreators.doRequestFinishProgramButtonFailure>;
